import React, { useState } from 'react';

interface Props {
  text: React.ReactNode;
  onShow?: (v: boolean) => void;
  width?: number;
  placement?: 'top' | 'bottom';
}

const InfoTooltip: React.FC<Props> = ({ text, onShow, width = 230, placement = 'top' }) => {
  const [show, setShow] = useState(false);
  const toggle = (v: boolean) => { setShow(v); onShow?.(v); };
  const vertical = placement === 'bottom'
    ? { top: 'calc(100% + 6px)' }
    : { bottom: 'calc(100% + 6px)' };
  return (
    <span
      style={{ position: 'relative', display: 'inline-block', marginLeft: '5px', verticalAlign: 'middle' }}
      onMouseEnter={() => toggle(true)}
      onMouseLeave={() => toggle(false)}
    >
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: '14px', height: '14px', borderRadius: '50%',
        border: '1px solid #d4d4d8', fontSize: '0.6rem',
        color: '#a1a1aa', cursor: 'help', userSelect: 'none',
        transition: 'border-color 0.15s, color 0.15s',
      }}>i</span>
      {show && (
        <div style={{
          position: 'absolute', right: 0, ...vertical,
          background: '#fff', border: '1px solid #f4f4f5', borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
          padding: '10px 12px', fontSize: '0.72rem', color: '#52525b',
          lineHeight: 1.5, width: `${width}px`, zIndex: 1000, pointerEvents: 'none',
        }}>
          {text}
        </div>
      )}
    </span>
  );
};

export default InfoTooltip;
